var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"admin-route-tab"},[_c('NavMenu',{attrs:{"menus":_vm.menus,"disable-collapse":"","mode":"horizontal"}}),_c('div',{staticClass:"router-view"},[_c('router-view',{key:_vm.$route.fullPath})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }